import React, { useContext, useEffect } from "react";
import { StyleSheet, Image, Switch, Text as Title } from "react-native";
import { useForm } from "react-hook-form";
import { Input, View, Text } from "../../components/Themed";
import Colors from "../../constants/Colors";
import GlobalContext from "../../context/Global";
import { DeviceType, getDeviceTypeAsync } from "expo-device";
import * as SecureStore from "expo-secure-store";
import ErrorMessage from "./ErrorMessage";
import InputText from "../../components/InputText";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";
import Pressable from "../../components/Pressable";

export const Login = ({ navigation }: any) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    trigger,
    setValue,
  } = useForm();

  const { setIsTablet, isTablet, login } = useContext(GlobalContext);

  useEffect(() => {
    getDeviceType();
  }, []);

  const getDeviceType = () => {
    const deviceTypeMap = {
      [DeviceType.UNKNOWN]: "unknown",
      [DeviceType.PHONE]: "phone",
      [DeviceType.TABLET]: "tablet",
      [DeviceType.DESKTOP]: "desktop",
      [DeviceType.TV]: "tv",
    };

    getDeviceTypeAsync().then((deviceType) => {
      setIsTablet(deviceTypeMap[deviceType] === "tablet" ? true : false);
      return deviceTypeMap[deviceType];
    });
  };

  const [keepMeLoggedIn, setKeepMeLoggedIn] = React.useState<boolean>(true);
  const [email, setEmail] = React.useState<string>("");
  const [password, setPassword] = React.useState<string>("");

  React.useEffect(() => {
    checkForAuthentication();
  }, []);

  React.useEffect(() => {
    if (email) setValue("email", email);
    if (password) setValue("password", password);
  }, [email, password]);

  const checkForAuthentication = async () => {
    // const authentication = await SecureStore.getItemAsync("authentication");
    // if (authentication) {
    //   const { email, password } = JSON.parse(authentication);
    //   setEmail(email);
    //   setPassword(password);
    //   setValue("email", email);
    //   setValue("password", password);
    // }
  };

  const loginUser = (data: { email: string; password: string }) => {
    login(data, keepMeLoggedIn);
  };

  return (
    <KeyboardAwareScrollView
      contentContainerStyle={[
        styles.signIn,
        { paddingTop: isTablet ? 80 : 24 },
      ]}
      keyboardShouldPersistTaps="handled"
    >
      <View style={styles.content}>
        <View style={styles.logo}>
          <Image
            resizeMode="contain"
            source={require("../../assets/logo.png")}
            style={{ height: isTablet ? "30%" : "25%" }}
          />
          <View style={styles.logoText}>
            <Title
              style={[
                styles.title,
                { fontSize: isTablet ? 48 : 26, marginTop: isTablet ? 0 : -16 },
              ]}
            >
              Open House
            </Title>
          </View>
          <View
            style={{
              width: isTablet ? "100%" : "85%",
              marginVertical: isTablet ? 16 : 8,
            }}
          >
            <ErrorMessage />
          </View>
        </View>
        <View
          style={[
            styles.modalContent,
            {
              marginTop: isTablet ? -72 : -60,
              marginHorizontal: isTablet ? 24 : 48,
            },
          ]}
        >
          <View style={styles.container}>
            <InputText
              placeholder="Email"
              label="Email"
              testingID="email_input"
              control={control}
              errors={errors}
              name="email"
              type="email-address"
              autoCapitalize="none"
              required
            />
            <InputText
              placeholder="Password"
              testingID="password_input"
              label="Password"
              control={control}
              errors={errors}
              name="password"
              autoCapitalize="none"
              required
              secureTextEntry
              onSubmitEditing={() => handleSubmit(loginUser)()}
            />
          </View>

          {/* <Pressable onPress={() => {}} style={styles.forgotPassword}>
            <Text style={{ color: Colors.primary_500 }}>Forgot Password?</Text>
          </Pressable> */}
          <View style={styles.keepMeLoggedIn}>
            <Text lightColor={Colors.nuetral_grey_700}>Keep Me Logged In</Text>
            <Switch
              testID="keep_me_logged_in"
              trackColor={{
                false: Colors.nuetral_grey_600,
                true: Colors.primary_500,
              }}
              thumbColor={false ? "#f5dd4b" : "#f4f3f4"}
              ios_backgroundColor={Colors.nuetral_grey_600}
              style={styles.switch}
              onValueChange={() => setKeepMeLoggedIn(!keepMeLoggedIn)}
              value={keepMeLoggedIn}
            />
          </View>
          <View style={{ alignSelf: "center" }}>
            <Pressable
              style={styles.signInButton}
              onPress={(data) => handleSubmit(loginUser)()}
            >
              <Text lightColor={Colors.base_colors_white}>Sign In</Text>
            </Pressable>
          </View>
        </View>

        {/* <View style={styles.orContainer}>
          <Text style={styles.orText} lightColor={Colors.nuetral_grey_600}>
            Or
          </Text>
        </View>

        <View style={styles.signInBrivityContainer}>
          <Text weight="Regular" lightColor={Colors.nuetral_grey_600}>
            Sign in with Brivity to sync to your Brivity CRM
          </Text>
          <Pressable
            onPress={() => {}}
            style={styles.signInBrivityButton}
          >
            <Image
              resizeMode="contain"
              source={require("../../assets/logo.png")}
              style={styles.signInBrivityButtonLogo}
            />
            <Text lightColor={Colors.primary_500}>Sign in with Brivity</Text>
          </Pressable>
        </View>

        <View style={styles.NewUser}>
          <Text lightColor={Colors.nuetral_grey_600}>
            New User?{" "}
            <Link style={{ color: Colors.primary_500 }} to={""}>
              Create Account
            </Link>
          </Text>
        </View> */}
      </View>
    </KeyboardAwareScrollView>
  );
};

const styles = StyleSheet.create({
  signIn: {
    flex: 1,
    alignItems: "center",
    backgroundColor: Colors.base_colors_white,
  },
  content: {
    gap: 16,
  },
  container: {
    height: 180,
    justifyContent: "space-between",
  },
  logo: {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  logoText: {
    marginTop: 36,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  modalContent: {
    height: 300,
  },
  title: {
    textTransform: "uppercase",
    color: Colors.nuetral_grey_700,
    fontFamily: "NunitoBold",
  },
  learnMoreText: {
    textAlign: "center",
  },
  forgotPassword: {
    alignSelf: "flex-end",
    marginTop: -9,
  },
  keepMeLoggedIn: {
    flexDirection: "row",
    alignItems: "center",
    alignSelf: "center",
    marginTop: 0,
  },
  keepMeLoggedInText: {
    fontSize: 16,
  },
  signInButton: {
    backgroundColor: Colors.primary_500,
    paddingHorizontal: 20,
    paddingVertical: 8,
    borderRadius: 100,
    marginTop: 26,

    zIndex: 2,
  },
  orContainer: {
    alignItems: "center",
    justifyContent: "center",
    fontSize: 16,
    borderBottomColor: Colors.nuetral_grey_400,
    borderBottomWidth: 1,
    marginHorizontal: 50,
  },
  orText: {
    marginBottom: -8,
    backgroundColor: Colors.base_colors_white,
    paddingHorizontal: 8,
  },
  signInBrivityContainer: {
    alignItems: "center",
    gap: 12,
  },
  signInBrivityButton: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    borderColor: Colors.primary_500,
    borderWidth: 1,
    borderRadius: 5,
    padding: 8,
    width: 214,
  },
  signInBrivityButtonLogo: {
    width: 22,
    height: 18,
    marginRight: 8,
  },
  NewUser: {
    alignItems: "center",
    justifyContent: "center",
  },
  switch: { transform: [{ scaleX: 0.8 }, { scaleY: 0.8 }] },
});
